import script from "./healthQuestionnaire.vue?vue&type=script&setup=true&lang=js"
export * from "./healthQuestionnaire.vue?vue&type=script&setup=true&lang=js"

import "./healthQuestionnaire.vue?vue&type=style&index=0&id=10da0bf8&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10da0bf8"]])

export default __exports__